import  React, { useState, useContext, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import WarningIcon from "@mui/icons-material/Warning";
import CustomSubCardData from "./CustomSubCardData";

import GridContainer from "components/CustomGrid/GridContainer.js";
import GridItem from "components/CustomGrid/GridItem.js";

import DataGridHome from "./DataGridHome"
import AdvancedSearchContext from "context/AdvancedSearchContext";


const Card = styled.div`
  border: 0 rgba(255, 0, 0, 0.1);
  margin-bottom: 0;
  margin-top: 0.5rem;
  color: #ffffff;
  background: #605F70;
  width: 100%;
  box-shadow: 0 1px 4px 0 grey;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: "break-word";
  font-size: ".875rem";
  border-radius: 6px;
  font-family: "Source Sans Pro",sans-serif;
`;

const DataContainer = styled.div`
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 0;
  margin-top: 0.5rem;
  color: #ffffff;
  background: #585667;
  width: 100%;
  position: relative;
  min-width: 0;
  word-wrap: break-word;
  font-size: 0.875rem;

`;

const CardTitle = styled.h3`
  margin-left: 0.9rem;
  margin-bottom: 0;
  font-size: 1.1rem;
  font-weight: 500;
  //font-family: "Poppins";
  color: #ffffff;
  font-family: "Source Sans Pro",sans-serif;
  margin-top: 0.7rem;
`;


function CustomCardDataGrid(props) {

  let year = new Date();
  year = new Date(year.setMonth(year.getMonth()-1));
  year = year.getFullYear();
  
const appContext = useContext(AdvancedSearchContext);
const { setChartIdGroup } = appContext;
  let rows = [];
  rows = props.rows?.map((destination, i) => {
    return { id: destination.id, name: destination.text, value: destination.value }
  })

  return (
    <div>
      <Card>
      <CardTitle>{"Top consommation par site "+ year + " (MWh)"}</CardTitle>
        <DataContainer>
          <DataGridHome columns={props.columns} rows={rows} onRowClick={props.onRowClick}
          
          />
        </DataContainer>
      </Card>
    </div>
  );
}

CustomCardDataGrid.propTypes = {
  columns: PropTypes.array,
    rows: PropTypes.array,
    onRowClick: PropTypes.func,
};

export default CustomCardDataGrid;
